import { Quiz } from './Quiz';
import { QuizResults } from './QuizResults';
import { QuizResult } from '../types';

interface QuizFlowProps {
    showQuiz: boolean;
    showQuizResults: boolean;
    quizResult: QuizResult | null;
    courseId: string;
    onQuizComplete: (result: QuizResult) => void;
    onQuizRetake: () => void;
    onQuizContinue: () => void;
}

export function QuizFlow({
    showQuiz,
    showQuizResults,
    quizResult,
    courseId,
    onQuizComplete,
    onQuizRetake,
    onQuizContinue
}: QuizFlowProps) {
    if (showQuiz) {
        return (
            <Quiz
                courseId={courseId}
                onComplete={onQuizComplete}
            />
        );
    }

    if (showQuizResults && quizResult) {
        return (
            <QuizResults
                result={quizResult}
                onRetake={!quizResult.passed ? onQuizRetake : undefined}
                onContinue={onQuizContinue}
            />
        );
    }

    return null;
}
